import request from "@/utils/request";

// 列表(主数据列表)
export function loadExpenseLoanListDataApi(data) {
  return request({
    url: "web/expenseLoan/listData",
    method: "post",
    data
  });
}
// 导出
export function loadExpenseLoanExportDataApi(data) {
  return request({
    url: "web/expenseLoan/exportData",
    method: "post",
    data
  });
}

// 获取下拉列表
export function getExpenseLoanListApi(data) {
  return request({
    url: "web/expenseLoan/listSelectData",
    method: "post",
    data
  });
}